import Info from "@material-symbols/svg-500/rounded/info.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const InfoIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Info });
	return <Icon />;
};

export default memo(InfoIcon);
